// react
import React, { Fragment, useEffect, useState } from "react";
// store
import { paymentService } from "../../../../store/services/ServicePayment";
import { LOADING_TIME } from "../../../../store/config";
// components
import HeaderTitle from "../../../../components/others/HeaderTitle";
import Loading from "../../../../components/others/Loading";
import InvoicesTable from "./InvoicesTable";
import { Card, Form, Button, Icon } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import moment from "moment";

// component
const Invoices = () => {

    // state
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({
        from: moment().startOf('month').format("DD.MM.YYYY"),
        to: moment().endOf('month').format("DD.MM.YYYY")
    })

    const [stats, setStats] = useState({
        totalInvoices: 0,
        totalPaid: 0,
        totalNonPaid: 0,
        paidPrice: 0,
    })
    const [isLoading, setIsLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [showFilters, setShowFilters] = useState(false);

    // fetch data
    async function fetchData() {
        setIsLoading(true);
        let params = `?from=${moment(filters.from, "DD.MM.YYYY").format("YYYY-MM-DD")}&to=${moment(filters.to, "DD.MM.YYYY").format("YYYY-MM-DD")}`;
        const result = await paymentService.getInvoicesForProvider(params);

        if (result.status === 200) {
            // calculate stats
            const invoices = result.response

            let totalPaid = 0;
            let totalPaidInvoices = 0;
            let totalNonPaidInvoices = 0;
            let totalInvoices = invoices.length;
            for (let i = 0; i < invoices.length; i++) {
                const price = invoices[i].total_amount
                if (invoices[i].status === 3) { // paid
                    totalPaid += parseFloat(price)
                    totalPaidInvoices += 1
                } else {
                    totalNonPaidInvoices += 1
                }
            }


            setData(invoices);
            setStats({
                totalInvoices: totalInvoices,
                totalPaid: totalPaidInvoices,
                totalNonPaid: totalNonPaidInvoices,
                paidPrice: totalPaid,
            })
        }

        setTimeout(function () {
            setIsLoading(false);
        }, LOADING_TIME);
    }

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const media = window.matchMedia("(max-width: 768px)");
        const handleChange = () => setIsMobile(media.matches);
        handleChange();
        if (media.addEventListener) {
            media.addEventListener("change", handleChange);
        } else {
            media.addListener(handleChange);
        }
        return () => {
            if (media.removeEventListener) {
                media.removeEventListener("change", handleChange);
            } else {
                media.removeListener(handleChange);
            }
        };
    }, []);

    const handleFilter = async () => {
        await fetchData()
        if (isMobile) {
            setShowFilters(false)
        }
    }

    // template
    return (
        <Fragment>
            <HeaderTitle title="Prehľad faktúr" />
            <section>
                {isMobile && (
                    <div style={{ marginBottom: "1rem" }}>
                        <div
                            onClick={() => setShowFilters(!showFilters)}
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "0.85rem 1rem",
                                background: "#f8f9fa",
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                cursor: "pointer",
                                transition: "all 0.2s ease"
                            }}
                        >
                            <div style={{ display: "flex", gap: "0.65rem" }}>
                                <Icon name="sliders horizontal" style={{ margin: 0, fontSize: "1.05rem", color: "#555" }} />
                                <span style={{ fontSize: "0.95rem", fontWeight: 600, color: "#333" }}>Filtrovať</span>
                            </div>
                            <div style={{ display: "flex", gap: "0.6rem" }}>
                                <span style={{ fontSize: "0.85rem", color: "#666", fontWeight: 500 }}>{filters.from} - {filters.to}</span>
                                <Icon name={showFilters ? "chevron up" : "chevron down"} style={{ margin: 0, fontSize: "0.95rem", color: "#555" }} />
                            </div>
                        </div>
                    </div>
                )}

                {(showFilters || !isMobile) && (
                    <Card fluid style={{ borderRadius: "8px", border: "1px solid #e0e0e0", marginBottom: "1rem", boxShadow: "none" }}>
                        <Card.Content style={{ padding: isMobile ? "1rem" : "1.25rem" }}>
                            <Form onSubmit={handleFilter}>
                                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr auto", gap: isMobile ? "1rem" : "1rem", alignItems: "end" }}>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Dátum od
                                        </label>
                                        <DateInput
                                            fluid
                                            required
                                            localization="sk"
                                            placeholder="DD.MM.YYYY"
                                            dateFormat="DD.MM.YYYY"
                                            value={filters.from}
                                            onChange={(e, { value }) => setFilters({ ...filters, from: value })}
                                            iconPosition="right"
                                            animation="none"
                                            closable
                                            hideMobileKeyboard
                                        />
                                    </Form.Field>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Dátum do
                                        </label>
                                        <DateInput
                                            fluid
                                            required
                                            localization="sk"
                                            placeholder="DD.MM.YYYY"
                                            dateFormat="DD.MM.YYYY"
                                            value={filters.to}
                                            onChange={(e, { value }) => setFilters({ ...filters, to: value })}
                                            iconPosition="right"
                                            animation="none"
                                            closable
                                            hideMobileKeyboard
                                        />
                                    </Form.Field>
                                    <Button
                                        fluid
                                        type="submit"
                                        style={{
                                            background: "var(--primary)",
                                            color: "#fff",
                                            borderRadius: "6px",
                                            fontWeight: 600,
                                            padding: "0.85rem 1.5rem",
                                            border: "none",
                                            minWidth: isMobile ? "100%" : "120px"
                                        }}
                                    >
                                        Potvrdiť
                                    </Button>
                                </div>
                            </Form>
                        </Card.Content>
                    </Card>
                )}
                {isLoading
                    ? <Loading />
                    :
                    <>
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: isMobile ? "repeat(3, minmax(0, 1fr))" : "repeat(3, 1fr)",
                                gap: isMobile ? "0.6rem" : "0.85rem",
                                marginBottom: "1rem"
                            }}
                        >
                            <div style={{
                                borderRadius: "8px",
                                padding: isMobile ? "0.9rem 0.7rem" : "1.1rem 1.2rem",
                                border: "1px solid #e0e0e0",
                                background: "#fff"
                            }}>
                                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                                    <div style={{ color: "#666", fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 500, marginBottom: "0.45rem", lineHeight: 1.2 }}>Celkovo</div>
                                    <div style={{ fontSize: isMobile ? "1.5rem" : "2rem", fontWeight: 700, color: "#333", lineHeight: 1 }}>{stats.totalInvoices}</div>
                                </div>
                            </div>
                            <div style={{
                                borderRadius: "8px",
                                padding: isMobile ? "0.9rem 0.7rem" : "1.1rem 1.2rem",
                                border: "1px solid #e0e0e0",
                                background: "#fff"
                            }}>
                                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                                    <div style={{ color: "#666", fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 500, marginBottom: "0.45rem", lineHeight: 1.2 }}>Zaplatené</div>
                                    <div style={{ display: "flex", alignItems: "baseline", gap: "0.5rem", justifyContent: isMobile ? "center" : "flex-start", flexWrap: "wrap", lineHeight: 1 }}>
                                        <span style={{ fontSize: isMobile ? "1.5rem" : "2rem", fontWeight: 700, color: "#00a651", lineHeight: 1 }}>{stats.totalPaid}</span>
                                        {stats.paidPrice > 0 && (
                                            <span style={{ fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 600, color: "#666", lineHeight: 1 }}>
                                                +{parseFloat(stats.paidPrice).toFixed(2)} €
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div style={{
                                borderRadius: "8px",
                                padding: isMobile ? "0.9rem 0.7rem" : "1.1rem 1.2rem",
                                border: "1px solid #e0e0e0",
                                background: "#fff"
                            }}>
                                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                                    <div style={{ color: "#666", fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: 500, marginBottom: "0.45rem", lineHeight: 1.2 }}>Nezaplatené</div>
                                    <div style={{ fontSize: isMobile ? "1.5rem" : "2rem", fontWeight: 700, color: "#db2828", lineHeight: 1 }}>{stats.totalNonPaid}</div>
                                </div>
                            </div>
                        </div>
                        <InvoicesTable invoices={data} isLoading={isLoading} />
                    </>
                }
            </section>
        </Fragment>
    );
};

export default Invoices;
